/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const TermsStatus = {
    Active: 'ACTIVE',
    Draft: 'DRAFT'
} as const;
export type TermsStatus = typeof TermsStatus[keyof typeof TermsStatus];


export function TermsStatusFromJSON(json: any): TermsStatus {
    return TermsStatusFromJSONTyped(json, false);
}

export function TermsStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): TermsStatus {
    return json as TermsStatus;
}

export function TermsStatusToJSON(value?: TermsStatus | null): any {
    return value as any;
}

